module.exports = __webpack_public_path__ + "img/up-arrow.94f09b78.png";